

export interface MenuProps {
    setMenuIx: (ix: number) => void;
    isAdmin: boolean;
}

// TODO przerobić na abstract class Menu
// TODO constructor z profilem umożliwiającym przełączanie składu menu w zależności od uprawnień
// TODO metoda abstreact menu()
export default class MenuConst {

    static readonly NONE:number = 0;

    static readonly MAIN:number = 1000;

    static readonly GOOD:number = 2000;

    static readonly ADMIN:number = 3000;

    static readonly ADMIN_REPORT:number = 4000;

}